module.exports = __webpack_public_path__ + "static/about_dev-e47ba56367315a6bfb6556dd93829162.jpg";